module.exports = __webpack_public_path__ + "img/fjc.99fb7f50.svg";